<template>
  <div class="container">
    <div class="row">
      <div class="col-sm-12 col-md-10 offset-md-1 col-lg-6 offset-lg-3">
        <v-form ref="form" v-if="loginshow" v-model="valid" @submit.prevent="loginsubmitForm">
        <div class="login-bg">
          <h1 class="text-start text-capitalize"><span>{{ $t("loginContents.buttonsLink.login") }}</span></h1>

          <div class="login-inp mb-0">
            <span>{{ $t("loginContents.labels.emailAddress") }}</span>

            <!-- <input type="text" placeholder="Email or Mobile Number" /> -->
            <v-text-field v-model="loginuser.userEmail" :rules="eMail" 
              variant="outlined" :placeholder="this.$t('loginContents.labels.emailAddress')" class="emailInput"
            style="min-height:30px;font-size: 15px !important"></v-text-field>
          </div>

          <div class="login-inp mb-0">
            <span>{{ $t("loginContents.labels.password") }}</span>

            <!-- <input type="text" placeholder="minimum 6 characters." /> -->
            <v-text-field v-model="loginuser.userPass" :rules="uPass" class="emailInput1"
            :placeholder="this.$t('loginContents.labels.password')" variant="outlined" required
              :append-inner-icon="visible ? 'mdi-eye-off' : 'mdi-eye'"
              :type="visible ? 'text' : 'password'" @click:append-inner="visible = !visible"
              style="min-height:30px;font-size: 15px !important;border-right:0px;"></v-text-field>
          </div>

          <a class="forgot" style="text-decoration: none"
            >{{ $t("loginContents.buttonsLink.forgotPassword") }}?</a
          >

          <label class="check">
            {{ $t("loginContents.labels.rememberMe") }}

            <input type="checkbox" checked="checked" />

            <span class="checkmark"></span>
          </label>

          <!-- <button type="submit" class="btn-login">Login</button> -->
          <button type="submit" class="btn btn-book px-5" :class="{'pe-none' : loadLogin}" style="background-color:#003580;color:white;
          height:45px;font-size:18px;">
            <v-progress-circular v-if="loadLogin" :width="5" color="white" indeterminate></v-progress-circular>
          {{ !loadLogin ? 'Login' : '' }}</button>

          <!-- <div class="orlogin">
            <span>OR LOGIN WITH</span>
          </div>

          <div class="login-social">
            <div class="row">
              <div class="col-sm-6 col-md-6 col-lg-6">
                <a href="#!" class="lfacebook" style="text-decoration: none">
                  <i class="fab fa-facebook"></i> Login with Facebook
                </a>
              </div>
              <div class="col-sm-6 col-md-6 col-lg-6">
                <a href="#!" class="lgoogle" style="text-decoration: none">
                  <i class="fab fa-google"></i> Login with Google
                </a>
              </div>
            </div>
          </div> -->

          <div class="orsignup">
            <span>Or</span>
          </div>

          <div class="create-acc">
            <a href="/register" style="text-decoration: none">
              {{ $t("loginContents.buttonsLink.createAccount") }}</a
            >
          </div>
        </div>
        </v-form>
      </div>
    </div>
  </div>
  {{ console.log(isActive,'isActiveee') }}
  <div class="toast" :class="isActive ? 'active' : ''" v-if="isActive">
        <div class="toast-content">
          <i class="bi bi-check toast-check"></i>
          <div class="message">
            <span class="message-text text-1">{{ $t("loginContents.labels.success") }}</span>
            <span class="message-text text-2">{{ $t("loginContents.labels.your") }} {{ Successmsg }}</span>
          </div>
        </div>

        <i class="bi bi-x-lg toast-close" @click="closeToast"></i>
        <div class="progress" :class="isActive ? 'active' : ''" :style="{ '--progress-color': progressColor }"></div>
    </div>


    <div class="toast" :class="isNotActive ? 'active border-danger' : ''">
        <div class="toast-content">
          <i class="bi bi-x-lg toast-check" :class="isNotActive ? 'bg-danger' : 'bg-danger'"></i>
          <div class="message">
            <span class="message-text text-1">{{ ErrorMessage }}</span>
            <span class="message-text text-2">{{ $t("loginContents.labels.errMsg") }}</span>
          </div>
        </div>

        <i class="bi bi-x-lg toast-close" @click="closeToast"></i>
        <div class="progress" :class="isNotActive ? 'active' : ''" :style="{ '--progress-color': progressColor }"></div>
    </div>
  <!--Content end-->
</template>
<script>
import axios from 'axios'
// import headerCom1 from "@/components/headerCom1.vue"; 

import { getConfigDataFromLocalStorage } from '@/localStorageData/localStorageUtil.js';

export default {
    components: {
        // registerCom,
        // headerCom1,
    },
    data() {
        return {
            loginbox: true,
            registerCom: false,
            terms: false,
            visible: false,
            loadLogin: false,
            btnDisabled: false,
            errorMsg: false,
            rememberCheck:false,

            loginshow: true,
            forgotshow: false,
            emailsentMsg: false,
            resetshow: false,
            loadforget: false,
            errforget: false,
            userName: "",
            userEmail: "",

            customKey: "qt3cU5nWjV2OPeQBEYkwD4adr8oy9I",
            customMail: "sarath@gmail.com",



            loginuser: {
                userEmail: "",
                userPass: "",
                confirmPass: "",
                dataPass : false,
            },

            resetDetail: {
                resetMail: "",
            },

            eMail: [
                v => !!v || 'Please enter your email',
                v => /.+@.+/.test(v) || 'E-mail must be valid',
            ],
            uPass: [
                v => !!v || 'Please enter your Password'
            ],

            loginReq: {
                "request_type": "user_login",
                "email": "",
                "password": "",
                "portal_id": "",
                "portal_domain":"",
                "token": "Tc7RQaX79Hrx5CFK"
            },

            forgetDetails: {
                "request_type": "forgot_password",
                "email": "irwogms@gmail.com",
                "user_id": "443355",
                "portal_id": "11111"
            },

            loginUrl: "",
            forgotPassword: "",





            // Register Code ----->

            valid: false,

            registerbox: false,
            loginSection: true,
            // terms: false,
            // visible: false,

            regForm: true,
            regMsg: false,
            registerMsg: "",
            loadRegister: false,
            // btnDisabled: false,

            personal: {
                username: "",
                email: "",
                password: "",
                rePassword: ""
            },



            // userName: [
            //     v => !!v || 'Please enter your Username',
            //     v => (v.length >= 3) || 'Name must be greater than 3 ',
            // ],

            // eMail: [
            //     v => !!v || 'E-mail is required',
            //     v => /.+@.+/.test(v) || 'E-mail must be valid',
            // ],

            passWord: [
                v => !!v || 'Please enter your Password',
                // v => (v && v.length >= 8) || 'Password must be at least 8 characters',
                // v => (v && v.length <= 20) || 'Password must be less than 20 characters',
                // v => (v && /[a-z]/.test(v)) || 'Password must contain at least one lowercase letter',
                // v => (v && /[!@#$%^&*]/.test(v)) || 'Password must contain at least one special character'
            ],
            repassWord: [
                v => !!v || 'Please enter your Re-password',
                v => v === this.personal.password || 'Passwords do not match'
            ],


            registerUrl: "",
            portalId:"",
            portalGroupId:"",
            portal_domain:"",


            // Register Code End ----->


            isActive: false,
            isNotActive: false,
            Successmsg:"",
            ErrorMessage:"",
            // getResData:'',
        }
    },


    methods: {

        showToast() {
      this.isActive = true;
      setTimeout(() => {
        if(this.isActive){
            this.isActive = false;
        console.log(this.isActive,'this.isActsivethis.isActsive....2')

        }
      }, 5000);
    },
    closeToast() {
      this.isActive = false;
      this.isNotActive = false;
    },

        signUp() {
            this.registerbox = true
            this.loginbox = false
        },


        onClickOutside() {
            this.loginbox = false
            console.log(this.loginbox, "5555555")
        },


        loginsubmitForm() {
            console.log(this.valid,'this.validthis.valid')
            if (this.valid) {

            this.loadLogin = true;

                console.log(this.valid, 'vvvvaaaallll')

                this.btnDisabled = true

                this.loginReq.email = this.loginuser.userEmail;
                this.loginReq.password = this.loginuser.userPass;
                this.loginReq.portal_id = this.portalId;
                this.loginReq.portal_domain = this.portal_domain;
                console.log(this.loginReq, 'vvvvvv.....')

                axios.post(this.loginUrl, this.loginReq, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })
                    .then(response => {
                        console.log('Response:', response.data);
                        if(response.data){
                            localStorage.setItem("loginuser", JSON.stringify(response.data))

                            this.errorMsg = false

                            this.Successmsg = response.data.message
                            this.rememberCheck = false;

                            this.loginbox = false;
                            this.loadLogin = false;
                            this.isActive =  true;

                            // localStorage.setItem('value', true);
                            // JSON.stringify(localStorage.setItem('loginDatas', this.loginuser))
                            let logindata = JSON.stringify(this.loginuser);
                            localStorage.setItem("loginDatas", logindata);

                            setTimeout(()=>{
                                // this.$refs.form.reset();
                                // this.$router.push('/');

                                // setInterval(() => {
                                //     location.reload();
                                // }, 500);

                            },5000)
                        }
                    })
                    .catch(error => {
                        console.log(this.valid, 'vvvvaaaallll....1')
                        console.error('Error:', error.response ? error.response.data : error.message);
                        this.errorMsg = true
                        this.isNotActive = true
                        this.ErrorMessage = error.response.data.message
                        this.loginuser.userEmail = null
                        this.loginuser.userPass = null


                        setTimeout(()=>{
                            this.isNotActive =  false;
                        },5000)
                        // alert("Incorrect email or password...")
                        this.loadLogin = false
                        this.btnDisabled = false
                    });
            }

        },



        submitResetForm() {
            // this.loginbox = false;

            if (this.valid) {
                // this.emailsentMsg = true
                // this.forgotshow = false
                this.loadforget = true

                this.forgetDetails.email = this.resetDetail.resetMail
                this.forgetDetails.user_id = this.resetDetail.resetMail
                this.forgetDetails.portal_id = this.portalId
                this.forgetDetails.portal_domain = this.portal_domain


                console.log(this.forgetDetails, 'reqqqqqqqqqq')

                axios.post(this.forgotPassword, this.forgetDetails, {
                    headers: {
                        'Content-Type': 'application/json'
                    }
                })

                    .then(response => {
                        console.log(response, 'rrrreeeeeessssssss.....')
                        this.loadforget = false
                        if (response.data.forgot_password_response == 'success') {
                            // this.forgotshow = false
                            this.emailsentMsg = true

                            this.Successmsg = response.data.msg

                            this.isActive =  true;

                            setTimeout(()=>{
                            this.isActive =  false;
                            this.loginshow = true;

                            this.$router.push('/');
                            setInterval(() => {
                                location.reload();
                            }, 500);
                        },5000)
                        }

                        else if (response.data.forgot_password_response == 'fail') {
                            this.forgotshow = true
                            this.emailsentMsg = false
                            this.loadforget = false
                            this.errforget = true
                        }
                    })
                    .catch(errors => {
                        console.log(errors, 'eeerrrrooorrr')
                        this.forgotshow = true
                    })

            }
        },

        closeLoginBox() {
            this.loginbox = false;
            this.$emit('close'); // Emit the 'close' event to the parent component
            console.log(this.loginbox, "1111111");
        },

        getConfig() {
            // let portalLocal = localStorage.getItem("portalData")
            // let getConfigData1 = JSON.parse(portalLocal)
            const getConfigData1 = getConfigDataFromLocalStorage();
            if (getConfigData1) {
                this.loginUrl = getConfigData1.payload.portal_configuration.API_endpoints.b2clogin
                this.registerUrl = getConfigData1.payload.portal_configuration.API_endpoints.b2cregister
                this.forgotPassword = getConfigData1.payload.portal_configuration.API_endpoints.forgot_password
                this.portalId = getConfigData1.payload.portal_configuration.portal_id
                this.portalGroupId = getConfigData1.payload.portal_configuration.portal_group_id;
                this.portal_domain = getConfigData1.payload.portal_configuration.portal_url.replace("https://","")

                console.log(this.getConfigData1, 'head...')
                console.log(this.loginUrl, 'head...reg..1..')
            }
        },




        // Regiter code

        signInAgain() {
            //   this.loginSection = true 
            this.loginbox = true
            this.registerbox = false
            console.log(this.loginSection, this.registerbox, "Workinglogin....")
        },
        // closeRegBox() {
        //         this.loginbox = false;
        //         this.$emit('close'); // Emit the 'close' event to the parent component
        //         console.log(this.loginbox, "1111111")
        //     },


        closeRegisterBox() {
            this.registerbox = false;
            this.$emit('close'); // Emit the 'close' event to the parent component
            console.log(this.registerbox, '00000')
        },


    },
    

    computed: {
        progressColor() {
         return this.isActive ? '#40f467' : '#ff0000';
        },
    },

    created() {
        this.getConfig();
    }
}
</script>

<style scoped>
@import "../../assets/css/style-04.css";
@import "../../assets/css/style-responsive.css";
/* @import "../../assets/css/style.css"; */
@import "../../assets/css/bootstrap.min.css";
@import "../../assets/css/custom.css";
@import "../../assets/css/slick/slick.css";
@import "../../assets/css/slick/slick-theme.css";

:deep(.emailInput .v-field__input){
  min-height:45px !important;
}
:deep(.emailInput1 .v-field__input){
  min-height:45px !important;
  border-right:0px;
}
.forgot{
  right:60px !important;
}
.main-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

/* .form-btn {
  padding-left: 40px;
  color: white;
} */

.btn-box {
    background-color: transparent;
    margin: 5px;
    padding: 2px;
    box-shadow: none;
}

.btn-active {
    background-color: blueviolet;
    color: white;
}

.v-checkbox .v-input__details {
    display: none;
}

>>>.v-label--clickable {
    cursor: pointer;
    font-size: 12px;
}

>>>.v-input__details {
    display: block !important;
}

.forgotStyle {
    font-weight: 500;
    font-size: 13px;
    letter-spacing: 1px;
    color: #0D6EFD;
    text-decoration: underline;
    cursor: pointer;
    text-align: end;
}


>>>.loginCard .v-input__control {
  height: 45px;
}

>>>.loginCard .v-field__field {
  height: 45px;
}

>>>.loginCard .v-field--focused {
  color: #002d5b;
  background-color: #ffffff;
  border-color: #ffc104;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgba(255, 193, 4, 0.5);
  border: none !important;
}
>>>.loginCard .v-field--variant-outlined.v-field--focused .v-field__outline {
  --v-field-border-width: 0px !important;
}

>>>.loginCard .v-text-field .v-field--no-label input,
.v-text-field .v-field--active input {
  opacity: 1;
  font-size: 15px;
  font-weight: 400;
  color: black;
  padding-top: 8px;
}


>>>.loginCard .v-field__input input::placeholder {
    position: relative;
    top: -10px;
}

>>>.loginCard .v-autocomplete .v-field__input input::placeholder {
    position: relative;
    top: 0px;
    
}









/* Login Page End */



@media only screen and (max-width: 992px) {

    .form-btn {
        padding: 10px 0px 0px 0px !important;
        /* color: white; */
    }

    .btn-box,
    .pipe {
        color: blueviolet !important;
    }

    .btn-active {
        background-color: blueviolet;
        color: white !important;
    }
}



/* Register code */

.main-page {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

/* .form-btn {
  padding-left: 40px;
  color: white;
} */

.btn-box {
    background-color: transparent;
    margin: 5px;
    padding: 2px;
    box-shadow: none;
}

.btn-active {
    background-color: blueviolet;
    color: white;
}

>>>.v-input__details {
    display: block !important;
}


/* .v-checkbox .v-input__details {
  display: none;
} */

/* Login Page End */



@media only screen and (max-width: 992px) {

    .form-btn {
        padding: 10px 0px 0px 0px !important;
        /* color: white; */
    }

    .btn-box,
    .pipe {
        color: blueviolet !important;
    }

    .btn-active {
        background-color: blueviolet;
        color: white !important;
    }
}






/* body{
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f2f2f2;
  overflow: hidden;
} */

.toast{
  position: absolute;
  top: 80px;
  right: 10px;
  border-radius: 6px;
  background: #fff;
  padding: 20px 35px 20px 25px;
  box-shadow: 0 5px 10px rgba(0, 0, 0, 0.1);
  border-left: 8px solid #40f467;
  overflow: hidden;
  /* transform: translateX(calc(100% + 30px)); */
  transition: all 0.5s cubic-bezier(0.68, -0.55, 0.25, 1.35);
}
.toast.active{
  transform: translateX(0);
}
.toast-content{
  display: flex;
  justify-content: center;
  align-items: center;
}
.toast-check{
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35px;
  width: 35px;
  background-color: #40f467;
  border-radius: 50%;
  color: #fff;
  font-size: 20px;
}
.message{
  display: flex;
  flex-direction: column;
  margin: 0 20px;
}
.message-text{
  font-size: 20px;
  font-weight: 600;
}
.text-1{
  color: #333;
}
.text-2{
  color: #666;
  font-weight: 400;
  font-size: 13px;
}
.toast-close{
  position: absolute;
  top: 10px;
  right: 15px;
  padding: 5px;
  cursor: pointer;
  opacity: 0.7;
}
.toast-close:hover{
  opacity: 1;
}
.progress{
  position: absolute;
  bottom: 0;
  left: 0;
  height: 3px;
  width: 100%;
  background: #ddd;
}

.progress::before{
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  height: 100%;
  width: 100%;
  background-color: var(--progress-color, #40f467);
  background-color: var(--progress-color, #ff0000);
}
.progress.active::before{
  animation: progress 5s linear forwards;
}

.toast:not(.show) {
    display: block;
}


@keyframes progress {
  100%{
    right: 100%;
  }
}
.toast-btn{
  padding: 10px 40px;
  font-size: 20px;
  outline: none;
  border: none;
  background-color: #40f467;
  color: #fff;
  border-radius: 50px;
  cursor: pointer;
  transition: 0.3s;
}
.toast-btn:hover{
  background-color: #0fbd35;
}

.forgotStyle{
    top:2px !important;
}
@media screen and (min-width:480px) {
    .forgotStyle{
        top:8px;
    }
}


</style>
